












































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'

settings =
  name: 'AdvanceList'
  components: { SuperContainerView, UiList }
  resources:
    advances:
      resourceName: 'advance'
      slug: 'advances'
      infinityScroll: true

  vue:
    data: ->
      searchValue: ''
      searchTimeout: null

    methods:
      hiOnRowClick: (item) ->
        # @$router.push({ name: 'AdvanceShowPage', params: { activationId: item.id } })

      hiFilterChange: ->
        @fetchInfinity(null, 'advances', @combinedFilters(), { page: 1 })

      combinedFilters: ->
        q = @searchValue
        return { q }

      coiStatus: (coi) ->
        return 'NOT REQUIRED' if !coi.required
        return 'READY' if coi.required and coi.completed
        return 'NOT READY' if coi.required and !coi.completed
      contractStatus: (contract) ->
        return 'NOT REQUIRED' if !contract.required
        return 'READY' if contract.required and contract.completed
        return 'NOT READY' if contract.required and contract !completed
      permitsStatus: (permits) ->
        return 'NOT REQUIRED' if !permits.required
        return 'READY' if permits.required and permits.completed
        return 'NOT READY' if permits.required and permits !completed

      getNeeds: (obj) ->
        needs = {}

        for key, value of obj
          needs[key] = obj[key]

          for nestedKey, nestedValue of obj[key]
            delete needs[key][nestedKey] if nestedValue != null

        delete needs.complete
        return needs

    watch:
      searchValue: (value) ->
        ctx = this
        window.stop()
        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.hiFilterChange()
        , 500)

export default VueOptions.vue settings
